import React from 'react';
import PropTypes from 'prop-types';

class PageSizeSelector extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    let {
      currentPageNumber,
      disabled,
      loadPage,
      sizes,
      style,
      totalNumberOfPages
    } = this.props;

    return (
      <div style={{color: disabled ? '#e0e0e0' : '', ...style}}>
        Show{this.renderPageSizes(sizes)}
      </div>
    );
  }
  
  renderPageSizes(sizes) {
    return sizes.map((size) => { 
      return this.renderPageSize(size);
    });
  }
  
  renderPageSize(size) {
    let { 
      currentPageSize,
      disabled, 
      pageSizeChanged 
    } = this.props;
    
    return (
      <span key={size}>
        {
          currentPageSize === size || disabled ?
            <span style={{
              paddingLeft: '8px', 
              cursor: 'default'
            }}>
              {size}
            </span>
            :
            <a 
              onClick={() => pageSizeChanged(size)}
              style={{
                paddingLeft: '8px', 
                cursor: 'pointer'
              }}
            >
              {size}
            </a>
        }
      </span>
    );
  }
}

PageSizeSelector.defaultProps = {
  currentPageSize: 10,
  sizes: [10, 20, 50],
};

PageSizeSelector.propTypes = {
  currentPageSize: PropTypes.number,
  disabled: PropTypes.bool,
  pageSizeChanged: PropTypes.func,
  sizes: PropTypes.array,
};

export default PageSizeSelector;
